import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
    <path
      d="M39 48H1c-.6 0-1-.4-1-1V5c0-.6.4-1 1-1h25c.6 0 1 .4 1 1s-.4 1-1 1H2v40h36V26c0-.6.4-1 1-1s1 .4 1 1v21c0 .6-.4 1-1 1z"
      fill="#0eb87f"
    />
    <path
      d="M29 8.1c-2 .3-13.1 10.8-6.1 17.9 2.5 2.5 7.9 2.1 14.5-4.5C44.1 14.8 47 2 47 2s-6.5 1-12.5 3.6c0 0-1.5 7.2-5.5 7.2V8.1z"
      fill="#c0f2d6"
    />
    <path
      d="M47.7 1.4c-.2-.3-.6-.4-.9-.4-.3 0-6.7 1-12.7 3.6-.3.1-.5.4-.6.7-.3 1.5-1.5 5.2-3.6 6.1V8.1c0-.3-.1-.6-.3-.7-.2-.2-.5-.3-.8-.2-1.8.1-6.8 4.8-8.6 9.9-1.2 3.4-.7 6.4 1.4 8.9l-7 7c-.4.4-.4 1 0 1.4.2.2.5.3.7.3s.5-.1.7-.3l7.1-7.1c1 .6 2.2 1 3.5 1 3.1 0 7.1-1.8 11.6-6.2 6.7-6.7 9.7-19.3 9.8-19.9 0-.3-.1-.6-.3-.8zm-11 19.3c-5.3 5.3-9.8 6.4-12.2 5.2l9.7-9.7c.4-.4.4-1 0-1.4s-1-.4-1.4 0L23 24.6c-1.4-1.8-1.8-3.9-1.1-6.3 1.1-3.8 4.3-7.1 6.1-8.5v2.9c0 .6.4 1 1 1 4.1 0 5.9-5.7 6.4-7.4 3.9-1.7 8.1-2.6 10.2-3-1 3.5-3.8 12.4-8.9 17.4z"
      fill="#0eb87f"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/page-content.es6.js